export default function PlaidIcon(props: { readonly color: string | undefined }) {
  return (
    <svg width="24px" height="24px" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <path
        d="m89.72 90.33 7.67-29.94-10.39-10.39 10.39-10.39-7.67-29.94-29.94-7.67-10.39 10.39-10.39-10.39-29.94 7.67-7.67 29.94 10.4 10.39-10.4 10.39 7.67 29.94 29.94 7.67 10.39-10.39 10.39 10.39zm-34.39-8.66 9.9-9.9 12.59 12.6-15.76 4zm-15.83-47.5 9.89-9.9 9.9 9.89-9.9 9.9zm4 15.83-9.89 9.9-9.95-9.9 9.9-9.9zm21.78-9.9 9.84 9.9-9.89 9.9-9.9-9.9zm-5.99 25.74-9.9 9.89-9.89-9.9 9.89-9.89zm-22.57 22.56-15.72-4.03 12.6-12.6 9.89 9.9zm-19-32.46 9.9 9.89-12.62 12.6-4-15.76zm-2.72-34.37 12.59 12.6-9.9 9.89-6.69-6.73zm28.42-3.24-9.89 9.9-12.53-12.6 15.75-4zm18.64-6.73 15.76 4-12.59 12.63-9.9-9.9zm19 32.46-9.89-9.89 12.59-12.6 4 15.76zm2.7 34.37-12.59-12.59 9.89-9.9 6.73 6.73z"
        fill={props.color}
      />
    </svg>
  );
}
